(function () {
  'use strict';

  var SUCCESS_GLYPH =
    '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
    '<path d="M1.5 5.5 3.5 8l5-6" stroke="currentColor" stroke-width="1.4"' +
    ' stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var _active = null;
  var _dismissTimer = null;

  function _dismiss(el) {
    if (!el || !el.isConnected) return;
    el.dataset.state = 'exiting';
    var done = function () { if (el.isConnected) el.remove(); };
    el.addEventListener('animationend', done, { once: true });
    setTimeout(done, 350);
  }

  window.lcToast = function (message, opts) {
    var region = document.getElementById('lc-toast-region');
    if (!region) return;

    var kind = opts && opts.kind;

    if (_active) {
      clearTimeout(_dismissTimer);
      _active.remove();
      _active = null;
    }

    var el = document.createElement('div');
    el.className = 'lc-toast';
    el.dataset.state = 'entering';

    if (kind === 'success') {
      var glyph = document.createElement('span');
      glyph.className = 'lc-toast__glyph';
      glyph.innerHTML = SUCCESS_GLYPH;
      el.appendChild(glyph);
    }

    var msg = document.createElement('span');
    msg.textContent = message;
    el.appendChild(msg);

    region.appendChild(el);
    _active = el;

    el.addEventListener('animationend', function () {
      if (el.dataset.state === 'entering') el.dataset.state = 'settled';
    }, { once: true });

    _dismissTimer = setTimeout(function () {
      _dismiss(el);
      _active = null;
    }, 4000);
  };
}());
